var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOkGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25031 11.0564L0 6.00027L1.74969 4.31529L5.25031 7.68645L12.2491 0.945312L14 2.6303L5.25031 11.0564Z",
    fill: "#498E2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkGreen);
export default __webpack_public_path__ + "static/media/ok-green.b1b00ca6743bf5e0b2266f0bf1f18f4e.svg";
export { ForwardRef as ReactComponent };